import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaSave } from 'react-icons/fa';
import api from '../../services/api';
import { useHistory } from 'react-router-dom';
import ReactSelect from '../../components/ReactSelect';
import { bin2hex, data, dataMysql, extract, pontoVirgula } from '../../util/util';
import Data from '../../components/Data';
import { toast } from 'react-toastify';
import InputMask from 'react-input-mask';
import { FinField, FinInput } from '../../components/FinField';
import '../../css/financeiro-parcela-pagar.css';


export default function CadastroEventoPergunta({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const nomeEmpresa = localStorage.getItem("nomeEmpresa");
    const [tabState, setTabState] = useState("geral");
    const token = localStorage.getItem('token');
    const idUsuario = localStorage.getItem("idUsuario");
    const nomeUsuario = localStorage.getItem("nomeUsuario");
    const perfil = localStorage.getItem("perfil");
    //dataCompetencia: new Date(),
    const [dados, setDados] = useState({
        responsavel: [idUsuario],
        nomeResponsavel: nomeUsuario,
        empresa: empresa,
        nomeEmpresa: nomeEmpresa
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(!!id);
    const history = useHistory();

    const buscar = () => {
        setIsLoading(true);
        if (id) {
            api({
                method: "get",
                action: '/evento/' + id,
                token: token,
            }).then(response => {
                //extrai dados internos para o array principal
                var dadosRecebidos = extract({
                    jsonLaravel: response.data.data,
                    chaves: [
                        'diretorresponsavel',
                        'cliente',
                        'empresa',
                        'municipio',
                        'pais',
                        'modelotermoaceite',
                        'modeloemailconvite',
                        'modelocontrato',
                        'modelocartaconvite',
                        'modelocarta',
                        'coordenadorrsvp',
                    ]
                });
                //transforma data para javascript
                dadosRecebidos.data = data(dadosRecebidos.data);
                dadosRecebidos.dataFim = data(dadosRecebidos.dataFim);
                dadosRecebidos.dataLimiteAceite = data(dadosRecebidos.dataLimiteAceite);
                dadosRecebidos.dataCompetencia = data(dadosRecebidos.dataCompetencia);
                dadosRecebidos.replanejadoInicio = data(dadosRecebidos.replanejadoInicio);
                dadosRecebidos.replanejadoFim = data(dadosRecebidos.replanejadoFim);
                dadosRecebidos.previsaoFaturamento = data(dadosRecebidos.previsaoFaturamento);

                if (dadosRecebidos.responsavel?.constructor !== Array)
                    dadosRecebidos.responsavel = [];
                dadosRecebidos.responsavel = dadosRecebidos.responsavel.map(function (objeto) {
                    return {
                        value: objeto.id,
                        label: objeto.nome
                    };
                });

                if (dadosRecebidos.responsavelcliente?.constructor !== Array)
                    dadosRecebidos.responsavelcliente = [];
                dadosRecebidos.responsavelcliente = dadosRecebidos.responsavelcliente.map(function (objeto) {
                    return {
                        value: objeto.id,
                        label: objeto.nome
                    };
                });

                setDados(dadosRecebidos);
            }).catch(err => {
                //console.log(err)
            }).finally(() => { setIsLoading(false); });
        }//if id
        else {
            setDados({
                ...dados,
                ...{
                    sistemaPergunta: 'sim',
                    pais: '30',
                    nomePais: 'Brasil'
                }
            });
            setIsLoading(false);
        }
    };

    const validar = () => {
        var nome = document.querySelector("#nome");
        if (nome.value === '') {
            toast.error('É necessário preencher o Nome do evento');
            setTimeout(() => {
                nome.focus();
            }, 500);
            setTabState("geral");
            return false;
        }
        var cliente = document.querySelector("#cliente");
        if (dados.cliente === undefined || dados.cliente === '') {
            toast.error('É necessário preencher o Cliente');
            setTimeout(() => {
                cliente.focus();
            }, 500);
            setTabState("geral");
            return false;
        }

        var dataEl = document.querySelector("#data");
        if (dataEl.value === '') {
            toast.error('É necessário preencher a Data de Início');
            setTimeout(() => {
                dataEl.focus();
            }, 500);
            setTabState("datas");
            return false;
        }

        return true;
    };

    const salvar = () => {
        if (!validar()) {
            return false; //para codigo aqui
        }

        if (dados.data) {
            dados.data = dataMysql(dados.data);
        }
        if (dados.dataFim) {
            dados.dataFim = dataMysql(dados.dataFim);
        }
        if (dados.dataLimiteAceite) {
            dados.dataLimiteAceite = dataMysql(dados.dataLimiteAceite);
        }
        if (dados.dataCompetencia) {
            dados.dataCompetencia = dataMysql(dados.dataCompetencia);
        }
        if (dados.replanejadoInicio) {
            dados.replanejadoInicio = dataMysql(dados.replanejadoInicio);
        }
        if (dados.replanejadoFim) {
            dados.replanejadoFim = dataMysql(dados.replanejadoFim);
        }
        if (dados.previsaoFaturamento) {
            dados.previsaoFaturamento = dataMysql(dados.previsaoFaturamento);
        }

        if (dados.responsavel?.constructor === Array) {
            dados.responsavel = dados.responsavel.map(item => item.value).join(',');
        }

        if (dados.responsavelcliente?.constructor === Array) {
            dados.responsavelcliente = dados.responsavelcliente.map(item => item.value).join(',');
        }

        setIsSubmitting(true);

        // Seguro terrestre (D-0094) é da aba Geral do evento: o valor de quando esta tela abriu
        // desfaria o seguro marcado depois por outra pessoa (ou seria barrado pela trava da apólice).
        const dadosEnvio = { ...dados };
        delete dadosEnvio.seguro_terrestre;
        delete dadosEnvio.arquivos_apolice_terrestre;

        if (id) {//update
            api({
                method: 'put',
                action: '/evento/' + id,
                token: token,
                data: dadosEnvio
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    //console.log(response.data);
                    history.push("/eventoPergunta");
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        } else {//insert
            api({
                method: 'post',
                action: '/evento',
                token: token,
                data: dados
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    //console.log(response.data);
                    history.push("/eventoPergunta");
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        }
    };

    useEffect(() => { //onload
        document.querySelector("#nome").focus(); //autofocus no nome
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Evento</h1></div>
                    <div className="fin-pp__actions">
                        <button type="button" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting} onClick={salvar}>
                            {isSubmitting ? <><span className="spinner-border spinner-border-sm me-2" />Salvando...</> : <><FaSave size={16} /> Salvar</>}
                        </button>
                    </div>
                </div>

                <form onSubmit={e => { salvar(); e.preventDefault(); }}>
                    {/* Tabs */}
                    <div className="fin-pp__tabs" style={{ marginBottom: 16 }}>
                        <button type="button" className={'fin-pp__tab' + (tabState === 'geral' ? ' is-active' : '')} onClick={() => setTabState('geral')}>Geral</button>
                        <button type="button" className={'fin-pp__tab' + (tabState === 'datas' ? ' is-active' : '')} onClick={() => setTabState('datas')}>Datas</button>
                        <button type="button" className={'fin-pp__tab' + (tabState === 'local' ? ' is-active' : '')} onClick={() => setTabState('local')}>Local</button>
                    </div>

                    {/* Tab: Geral */}
                    {tabState === 'geral' && (
                        <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                            <div className="fin-pp__filters">
                                <FinField label="Empresa">
                                    <ReactSelect
                                        id="empresa"
                                        value={{ value: dados.empresa, label: dados.nomeEmpresa }}
                                        onChange={e => setDados({ ...dados, ...{ "empresa": e.value, "nomeEmpresa": e.label } })}
                                        loadOptions={(input) => {
                                            return api({
                                                method: 'get',
                                                action: '/participante',
                                                token: token,
                                                params: {
                                                    nome: input,
                                                    tipoCadastro: "empresa",
                                                    situacaoRegistro: "ativo",
                                                }
                                            })
                                                .then(response => {
                                                    let options = response.data.data.map((registro) => {
                                                        var label = registro.codigo +
                                                            ' - ' + registro.nome +
                                                            (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
                                                            (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                            (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                            (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
                                                        return { value: registro.id, label: label };
                                                    });
                                                    return options;
                                                })
                                                .catch(function (error) {
                                                    //console.log(error);
                                                });
                                        }}
                                    />
                                </FinField>
                                <FinField label="Cliente" full>
                                    <ReactSelect
                                        id="cliente"
                                        value={{ value: dados.cliente, label: dados.nomeCliente }}
                                        onChange={e => setDados({ ...dados, ...{ "cliente": e.value, "nomeCliente": e.label } })}
                                        loadOptions={(input) => {
                                            return api({
                                                method: 'get',
                                                action: '/participante',
                                                token: token,
                                                params: {
                                                    nome: input,
                                                    tipoCadastro: "cliente",
                                                    situacaoRegistro: "ativo",
                                                }
                                            })
                                                .then(response => {
                                                    let options = response.data.data.map((registro) => {
                                                        var label = registro.codigo +
                                                            ' - ' + registro.nome +
                                                            (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
                                                            (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                            (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                            (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
                                                        return { value: registro.id, label: label };
                                                    });
                                                    return options;
                                                })
                                                .catch(function (error) {
                                                    //console.log(error);
                                                });
                                        }}
                                    />
                                </FinField>
                                <FinField label="Identificação">
                                    <FinInput
                                        type="text"
                                        id="identificacao"
                                        value={dados.identificacao || ''}
                                        onChange={e => setDados({ ...dados, ...{ "identificacao": e.target.value } })}
                                    />
                                </FinField>
                                <FinField label="Nome do Evento" full>
                                    <FinInput
                                        type="text"
                                        id="nome"
                                        value={dados.nome || ''}
                                        onChange={e => setDados({ ...dados, ...{ "nome": e.target.value } })}
                                    />
                                </FinField>
                            </div>

                            <div className="fin-pp__filters" style={{ marginTop: 16 }}>
                                <FinField label="Logomarca (.jpeg)">
                                    <input
                                        type="file"
                                        multiple={false}
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="logomarca"
                                        onChange={(e) => {
                                            var nomeLogomarca = e.target.value;
                                            //transforma binario em json hexadecimal
                                            const fileReader = new FileReader();
                                            fileReader.readAsBinaryString(e.target.files[0]);
                                            fileReader.onload = e => {
                                                setDados({
                                                    ...dados,
                                                    ...{
                                                        "nomeLogomarca": nomeLogomarca,
                                                        "binarioLogomarca": bin2hex(e.target.result),
                                                    }
                                                });
                                            };
                                        }}
                                    />
                                </FinField>
                                <FinField label="Imagem de Fundo (.jpeg)">
                                    <input
                                        type="file"
                                        multiple={false}
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="imagemfundo"
                                        onChange={(e) => {
                                            var nomeImagemfundo = e.target.value;
                                            //transforma binario em json hexadecimal
                                            const fileReader = new FileReader();
                                            fileReader.readAsBinaryString(e.target.files[0]);
                                            fileReader.onload = e => {
                                                setDados({
                                                    ...dados,
                                                    ...{
                                                        "nomeImagemfundo": nomeImagemfundo,
                                                        "binarioImagemfundo": bin2hex(e.target.result),
                                                    }
                                                });
                                            };
                                        }}
                                    />
                                </FinField>
                            </div>

                            {dados.logomarca?.link && (
                                <div style={{ marginTop: 12 }}>
                                    <img alt="" src={dados.logomarca.link} width={"400px"} />
                                </div>
                            )}
                            {dados.imagemfundo?.link && (
                                <div style={{ marginTop: 12 }}>
                                    <img alt="" src={dados.imagemfundo.link} width={"400px"} />
                                </div>
                            )}
                        </div>
                    )}

                    {/* Tab: Datas */}
                    {tabState === 'datas' && (
                        <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                            <div className="fin-pp__filters">
                                <FinField label="Data Inicial">
                                    <Data
                                        id={"data"}
                                        label="Data Inicial"
                                        value={dados.data}
                                        onChange={date => setDados({ ...dados, ...{ "data": date } })}
                                    />
                                </FinField>
                                <FinField label="Horário Inicial">
                                    <InputMask
                                        mask="99:99"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="hora"
                                        placeholder="Horário Inicial"
                                        value={dados.hora || ''}
                                        onChange={e => setDados({ ...dados, ...{ "hora": e.target.value } })}
                                    />
                                </FinField>
                                <FinField label="Data Final">
                                    <Data
                                        label="Data Final"
                                        value={dados.dataFim}
                                        onChange={date => setDados({ ...dados, ...{ "dataFim": date } })}
                                    />
                                </FinField>
                                <FinField label="Horário Final">
                                    <InputMask
                                        mask="99:99"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="horaFim"
                                        placeholder="Horário Final"
                                        value={dados.horaFim || ''}
                                        onChange={e => setDados({ ...dados, ...{ "horaFim": e.target.value } })}
                                    />
                                </FinField>
                            </div>
                        </div>
                    )}

                    {/* Tab: Local */}
                    {tabState === 'local' && (
                        <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                            <div className="fin-pp__filters">
                                <FinField label="Local" full>
                                    <FinInput
                                        type="text"
                                        id="local"
                                        value={dados.local || ''}
                                        onChange={e => setDados({ ...dados, ...{ "local": e.target.value } })}
                                    />
                                </FinField>
                                <FinField label="Endereço" full>
                                    <FinInput
                                        type="text"
                                        id="endereco"
                                        value={dados.endereco || ''}
                                        onChange={e => setDados({ ...dados, ...{ "endereco": e.target.value } })}
                                    />
                                </FinField>
                                <FinField label="Cidade">
                                    <ReactSelect
                                        value={{ value: dados.municipio, label: dados.nomeMunicipio }}
                                        onChange={e => setDados({ ...dados, ...{ "municipio": e.value, "nomeMunicipio": e.label } })}
                                        loadOptions={(input) => {
                                            return api({
                                                method: 'get',
                                                action: '/municipio',
                                                token: token,
                                                params: { nome: input }
                                            })
                                                .then(response => {
                                                    let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome + "-" + registro.uf }));
                                                    return options;
                                                })
                                                .catch(function (error) {
                                                    //console.log(error);
                                                });
                                        }}
                                    />
                                </FinField>
                                <FinField label="Município Exterior">
                                    <FinInput
                                        type="text"
                                        id="municipioExterior"
                                        value={dados.municipioExterior || ''}
                                        onChange={e => setDados({ ...dados, ...{ "municipioExterior": e.target.value } })}
                                    />
                                </FinField>
                                <FinField label="Bairro">
                                    <FinInput
                                        type="text"
                                        id="bairro"
                                        value={dados.bairro || ''}
                                        onChange={e => setDados({ ...dados, ...{ "bairro": e.target.value } })}
                                    />
                                </FinField>
                                <FinField label="País">
                                    <ReactSelect
                                        value={{ value: dados.pais, label: dados.nomePais }}
                                        onChange={e => setDados({ ...dados, ...{ "pais": e.value, "nomePais": e.label } })}
                                        loadOptions={(input) => {
                                            return api({
                                                method: 'get',
                                                action: '/pais',
                                                token: token,
                                                params: { nome: input }
                                            })
                                                .then(response => {
                                                    let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome }));
                                                    return options;
                                                })
                                                .catch(function (error) {
                                                    //console.log(error);
                                                });
                                        }}
                                    />
                                </FinField>
                            </div>
                        </div>
                    )}

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 24 }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting}>
                            {isSubmitting ? <><span className="spinner-border spinner-border-sm me-2" />Salvando...</> : <><FaSave size={16} /> Salvar</>}
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
